import constants from '../constants';

export default {
  userIsLoged(){
    axios.post(constants.ROOT_URL + '/api/v1/get_user')
      .then((response) => {

      }, (response) => {
        console.log(response.data);
        this.tokenValidCalls(response, this);
      });
  },

  tokenValidCalls(response, out) {
    window.localStorage.removeItem(constants.STORAGE_TOKEN_KEY);
    window.localStorage.removeItem('system');
    out.$router.push({path: 'login'});
  },

  selectTranslation(trans_cat,  trans_es){
    var lang = window.localStorage.getItem('lang')

    switch (lang) {
      case 'cat':
        // console.log(trans_cat);
        return trans_cat;
        break;
      case 'es':
        // console.log(trans_cat);
        return trans_es;
        break;
      // case 'en':
      //   console.log('El kilogramo de Bananas cuesta $0.48.');
      //   break;
      default:
        //CAT
        return trans_cat;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utilities/middlewares.js